import PropTypes from "prop-types";

// MUI
import { Skeleton, Stack } from "@mui/material";

// Icons
import CircledEqual from "@/assets/icons/matches/circled_equal.svg";
import CircledSimilar from "@/assets/icons/matches/circled_similar.svg";

const isLabelIncluded = (label, matches = []) => matches.includes(label);

function RenderMatch(props) {
	const { loading, match } = props;
	return (
		<Stack direction="row" alignContent={"center"} alignItems={"center"} ml={"5px"} sx={{ minWidth: "18px" }}>
			{loading ? <Skeleton variant="circular" width={18} height={18} /> : match}
		</Stack>
	);
}
RenderMatch.propTypes = {
	match: PropTypes.node,
	loading: PropTypes.bool,
};

export default function MatchList(props) {
	const { label, matches = { partialMatchList: [], fullMatchList: [] }, isSelected, loading } = props;

	if (isSelected) {
		return <RenderMatch loading={false} />;
	}

	let image = "";
	const isFullMatch = isLabelIncluded(label, matches.fullMatchList);
	const isMatchIncluded = isFullMatch || isLabelIncluded(label, matches.partialMatchList);

	if (isMatchIncluded) {
		image = <img src={CircledSimilar} width="18px" alt="match" />;
		if (isFullMatch) {
			image = <img src={CircledEqual} width="18px" alt="match" />;
		}
	}

	return <RenderMatch loading={loading} match={image} />;
}

MatchList.propTypes = {
	label: PropTypes.string,
	matches: PropTypes.shape({
		partialMatchList: PropTypes.arrayOf(PropTypes.string),
		fullMatchList: PropTypes.arrayOf(PropTypes.string),
	}),
	isSelected: PropTypes.bool,
	loading: PropTypes.bool,
};
